import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Logo from 'images/logo.png';
import commonStyles from '../commonStyles';
import defaultTextValue from '../defaultTextValue';
const styles = StyleSheet.create({
    header: {
        display: 'flex',
        flexDirection: 'row',
        marginHorizontal: commonStyles.marginHorizontal,
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #c4c4c4',
        height: '9.5%',
        marginBottom: '3%',
    },
    titleWrapper: Object.assign({ display: 'flex', flexDirection: 'row' }, commonStyles.fontM),
    title: {
        fontWeight: 'bold',
        wordBreak: 'break-all',
    },
    logo: {
        marginRight: '4%',
        height: 25,
        objectFit: 'contain',
    },
});
function Header({ title }) {
    return (React.createElement(View, { style: styles.header, fixed: true },
        React.createElement(View, { style: styles.titleWrapper },
            React.createElement(Text, { style: styles.title }, defaultTextValue(title).slice(0, 63))),
        React.createElement(Image, { style: styles.logo, src: Logo })));
}
export default withTranslation('specification')(Header);
